import type React from 'react';
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import { UserTypeEnum } from '../../types/user-type.ts';

const LazyAdminUser = lazy(() => import('./AdminUser'));

const AdminUser = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  const { user } = useAuth();
  return (
    <Suspense fallback={<PageLoading />}>
      {user?.userType === UserTypeEnum.Admin ? (
        <LazyAdminUser {...props} />
      ) : user?.userType === UserTypeEnum.DrugRep || user?.userType === UserTypeEnum.StaffMember ? (
        <Navigate to='/dashboard' />
      ) : null}
    </Suspense>
  );
};

export const adminUserRoute = {
  path: '/admin-user',
  element: <AdminUser />,
};
export default AdminUser;
